import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants';

/*

Props:
    altShadow
    width
    height
    circle

*/

const StyledDiv = styled.div`
    /* display: flex; */
    width: ${props => (props.width) ? props.width : 'auto' };
    max-width: 95%;
    height: ${props => (props.height) ? props.height : 'auto' };
    ${props => (props.circle) ? 'border-radius: 50%;' : ''}
    box-shadow: -5px -1px 20px 0px rgba(0,0,0,0.1);
    ${props => (props.altShadow) ? 'box-shadow: 2px 5px 20px 0px rgba(0,0,0,0.1);' : ''}
    @media (max-width: ${props => (props.noBreakPoint) ? '0' : constants.layout.breakpoint.break1}px){
        
    }
`;


const DropShadow = ({ style, children, ...rest }) => (
    <StyledDiv id="DropShadow" style = {style} {...rest} >
        { children }
    </StyledDiv>
)

export default DropShadow;



// WEBPACK FOOTER //
// ./src/js/components/Primatives/DropShadow.jsx